import { AxiosResponse } from 'axios'
import axios from '@/services/axios'

export default abstract class CategoriesApi {
  public static route = process.env.VUE_APP_SHOP_V2_BASE_URI
  public static entity = 'categories'

  public static async get(): Promise<AxiosResponse> {
    return await axios.get(`${this.route}/${this.entity}`)
  }
}
